import { authFetch } from './authFetch';

const API_BASE_URL = import.meta.env.VITE_API_URL ?? ''

export interface ExecuteAiJobsRequest {
  userMessage?: string;
  jobs?: Record<string, unknown>[];
  sceneId?: number | null;
  currentFrame?: number | null;
  conversationId?: number | null;
}

export interface ExecutedAiJobResult {
  index: number;
  worker: string;
  status: 'applied' | 'failed' | 'skipped' | 'queued';
  detail?: string;
  libraryObjectId?: number;
  fileName?: string;
  displayName?: string;
  libraryObject?: import('../types/api').LibraryObjectResponse;
}

export interface ExecuteAiJobsResponse {
  intent?: unknown;
  plan?: unknown;
  results: ExecutedAiJobResult[];
}

export async function executeAiJobs(
  movieId: number,
  request: ExecuteAiJobsRequest
): Promise<ExecuteAiJobsResponse> {
  const response = await authFetch(`${API_BASE_URL}/api/movies/${movieId}/ai/execute-jobs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(errorBody || `execute-jobs failed: ${response.status}`);
  }

  return (await response.json()) as ExecuteAiJobsResponse;
}
